import { lazyOpenBizChatSidePane } from 'owa-bizchat-shared';
import type { BizChatSidePaneSources } from 'owa-bizchat-types';
import { isFeatureEnabled } from 'owa-feature-flags';

export interface mailCopilotRouteParameters {
    deeplink?: string;
}

export async function mailCopilotNavigationRouteHandler(
    params: mailCopilotRouteParameters
): Promise<void> {
    if (isFeatureEnabled('mon-copilot-bizchat')) {
        const source: BizChatSidePaneSources = 'MailRouteDeeplink';

        await lazyOpenBizChatSidePane.importAndExecute({
            source,
            encodedDeepLink: params.deeplink,
        });
    }
}
